<template>
  <div class="modal-card">
    <header class="modal-card-head">
      <p class="modal-card-title">
        <span>
          {{ $t("surveyLinks") }}
        </span>
      </p>
    </header>
    <section class="modal-card-body">
      <CopyLink :href="surveyLink" :label="$t('linkToSurvey')" />
      <CopyLink :href="adminSurveyLink" :label="$t('linkToAdminSurvey')" />
      <CopyLink :href="presentationSurveyLink" :label="$t('linkToPresentationSurvey')" />
    </section>
    <footer class="modal-card-foot">
      <button class="button is-info" type="button" @click="$parent.close()">
        {{ $t("close") }}
      </button>
    </footer>
  </div>
</template>

<script>
import { BASE_URL } from "@/env";
import CopyLink from "./CopyLink";
import { db } from "@/firebase";

export default {
  name: "AdminLinks",
  components: {
    CopyLink,
  },
  props: {
    surveyCode: {
      type: String,
      default: "",
    },
    surveyId: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      isLoading: false,
      isDisabled: false,
      baseURL: "",
      moderationPw: null,
    };
  },
  computed: {
    surveyLink() {
      return `${BASE_URL}/polling/participate/${this.surveyCode}`;
    },
    adminSurveyLink() {
      return `${BASE_URL}/polling/admin/${this.surveyCode}/${this.moderationPw}`;
    },
    presentationSurveyLink() {
      return `${BASE_URL}/polling/presentation/${this.surveyCode}/${this.moderationPw}`;
    },
  },
  watch: {
    surveyId: {
      immidiate: true,
      async handler() {
        this.loadModerationPw();
      },
    },
  },
  mounted() {
    this.loadModerationPw();
  },
  methods: {
    async loadModerationPw() {
      this.moderationPw = null;
      this.isLoading = true;
      this.isDisabled = true;
      this.moderationPw = (
        await db.collection("surveys").doc(this.surveyId).collection("data").doc("moderationPw").get()
      ).data().moderationPw;
      this.isLoading = false;
      this.isDisabled = false;
    },
  },
};
</script>

<style></style>
